const autoNgTemplateLoaderTemplate1 = require('./foods.template.html');

'use strict';

import { NAVIGATION_ICON } from '../../modules/shared/constants/system/navigationIcons';
import { SOLUTION_TYPE } from '../../modules/shared/constants/user-info/solutionType';

(function () {
    angular
        .module('app.foods', [])
        .component('foods', {
            templateUrl: autoNgTemplateLoaderTemplate1,
            controller: 'FoodsController',
            controllerAs: 'vm'
        })
        .config(foodsConfig);

    foodsConfig.$inject = ['$routeProvider'];

    function foodsConfig($routeProvider) {
        $routeProvider
            .when('/angular/foods/:type', {
                disableCache: true,
                template: '<foods></foods>',
                resolve: {
                    loginRequired: ['AuthService', function (AuthService) {
                        return AuthService.loginRequired();
                    }]
                },
                pageConfig: {
                    solution: SOLUTION_TYPE.NUTRITION,
                    breadcrumbs: [
                        { label: 'Food List MGMT', icon: NAVIGATION_ICON.FOLDER_OPEN }
                    ]
                }
            })
    }
})();
